import ToggleBox from '@/components/Common/ToggleBox';
import { mapActions, mapGetters } from 'vuex';
import sPackage from '@/services/sPackage';

export default {
  name: 'FeatureTile',

  components: { ToggleBox },

  props: {
    service: {
      type: Object,
      default: (() => { })
    },
    hide_price: {
      type: Boolean,
      default: (() => true)
    },
    servicesList: {
      type: Array,
      default: (() => [])
    }
  },

  data() {
    return {
      arrow: require("@/assets/arrow-up.svg"),
      expanded: false,
    };
  },

  computed: {
    ...mapGetters(['packageUsage']),
    statusMessage() {
      if (this.service.is_active) {
        return 'AKTYWNA';
      } else {
        return '';
      }
    },
    expandLabel() {
      if (this.expanded) {
        return 'Zwiń szczegóły';
      } else {
        return 'Pokaż szczegóły';
      }
    },
    title() {
      return this.service.label;
    },
    subtitle() {
      return this.service.short_description;
    },
    description() {
      return this.service.description;
    },
    charge() {
      return this.service.charge;
    },
    toggleable() {
      return this.service.is_toggleable;
    },
    is_changing() {
      return this.service.changing_value !== undefined && this.service.changing_value !== null && this.service.changing_value !== this.is_active;
    },
    active() {
      return this.service.is_active || this.servicesList.filter(
        service => service.feature_ext_name !== undefined
                && service.feature_ext_name !== null
                && service.feature_ext_name === this.service.feature_ext_name
                && (service.is_active || service.changing_value)
      ).length > 0;
    },
  },

  methods: {
    ...mapActions(['getPackageUsage']),
    toggleDescription() {
      this.expanded = !this.expanded;
    },
    showPacketActivation() {
      this.$EventBus.$emit('Service/TOGGLE_MODAL_WITH_STATUS_CHANGE', this.service);
    },
  },

  created() {
    this.usage = 0;
    this.gb2str = sPackage.gb2str;
    // używany globalny cache, gdyż vue stawia dwie instancje, z czego jedną od razu niszczy
    try {
      if (this.service.is_active && !this.service.is_toggleable && !this.is_changing) {
        const storageKey = `usage cache of ${this.service.uuid}`;
        if (window[storageKey] === undefined) {
          window[storageKey] = this.getPackageUsage({feature: this.service.uuid});
        }
        window[storageKey].then((packageUsage)=>{     
          window[storageKey] = undefined;
          this.usage = Number(packageUsage.main_remaining_units);   
          if (this.usage > 0) {
            this.$forceUpdate();
          }
        });
      }
    } catch (exception) {
      // podczas testów nie ma dostępu do getPackageUsage, a porównanie z undefined nie działa
      if (!(exception instanceof TypeError)) {
        throw exception;
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/Services/FeatureTile/component.js